function normalizeBase(value) {
  return String(value || '').trim().replace(/\/+$/, '');
}

function normalizeAssetPath(assetPath) {
  return String(assetPath || '').trim().replace(/^\/+/, '');
}

function isFileHostedRuntime() {
  if (typeof window === 'undefined') return false;
  return (
    window.__TRILL_PLATFORM__ === 'brightsign' ||
    window.location?.protocol === 'file:'
  );
}

export function resolveRuntimeAssetUrl(assetPath) {
  const normalizedAssetPath = normalizeAssetPath(assetPath);
  if (!normalizedAssetPath) {
    return '';
  }

  const explicitBase = normalizeBase(
    typeof window !== 'undefined'
      ? (
          window.__TRILLBOARDS_ASSET_BASE ||
          window.__TRILLBOARDS_SCREEN_ASSET_BASE ||
          window.__TRILLBOARDS_BRIGHTSIGN?.screenUrl
        )
      : ''
  );

  if (explicitBase && isFileHostedRuntime()) {
    return `${explicitBase}/${normalizedAssetPath}`;
  }

  const publicBase = normalizeBase(process.env.PUBLIC_URL || '');
  if (publicBase) {
    return `${publicBase}/${normalizedAssetPath}`;
  }

  return `/${normalizedAssetPath}`;
}

export default resolveRuntimeAssetUrl;
